import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const SECTION_BORDER = '1px solid #F0F0F5';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 16,
    overflow: 'hidden',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
    borderBottom: SECTION_BORDER,
  },

  title: {
    fontSize: 20,
    lineHeight: 1.6,
    fontWeight: 'bold',
  },

  count: {
    color: theme.palette.secondary.contrastText,
    fontWeight: 400,
  },

  summary: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}));

interface Props {
  id?: string;
  title: string;
  count?: number;
  summary?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const DetailsSectionCard = ({ id, title, count, summary, action, children }: Props) => {
  const classes = useStyles();

  return (
    <Paper id={id} component="section" className={classes.root}>
      <div className={classes.header}>
        <Typography component="h2" className={classes.title}>
          {title}
          {typeof count === 'number' && <span className={classes.count}> ({count})</span>}
        </Typography>
        {summary && <span className={classes.summary}>{summary}</span>}
        {action}
      </div>
      {children}
    </Paper>
  );
};

export default DetailsSectionCard;
